import { CONTROL_ATTRIBUTES } from '../../utils/enums';
const ACTIVATE_EVENT_KEY = 'campaign_activated';
const CUSTOM_ATTRIBUTE_FEATURE_TYPE = 'custom';
export const logxEndpoint = {
    US: 'https://logx.optimizely.com/v1/events',
    EU: 'https://eu.logx.optimizely.com/v1/events',
};
/**
 * Given an array of batchable Decision or ConversionEvent events it returns
 * a single EventV1 with proper batching
 *
 * @param {UserEvent[]} events
 * @returns {EventBatch}
 */
export function makeEventBatch(events) {
    const visitors = [];
    const data = events[0];
    events.forEach(event => {
        if (event.type === 'conversion' || event.type === 'impression') {
            const visitor = makeVisitor(event);
            if (event.type === 'impression') {
                visitor.snapshots.push(makeDecisionSnapshot(event));
            }
            else if (event.type === 'conversion') {
                visitor.snapshots.push(makeConversionSnapshot(event));
            }
            visitors.push(visitor);
        }
    });
    return {
        client_name: data.context.clientName,
        client_version: data.context.clientVersion,
        account_id: data.context.accountId,
        project_id: data.context.projectId,
        revision: data.context.revision,
        anonymize_ip: data.context.anonymizeIP,
        enrich_decisions: true,
        visitors,
    };
}
function makeConversionSnapshot(conversion) {
    const tags = Object.assign({}, conversion.tags);
    delete tags['revenue'];
    delete tags['value'];
    const event = {
        entity_id: conversion.event.id,
        key: conversion.event.key,
        timestamp: conversion.timestamp,
        uuid: conversion.uuid,
    };
    if (conversion.tags) {
        event.tags = conversion.tags;
    }
    if (conversion.value != null) {
        event.value = conversion.value;
    }
    if (conversion.revenue != null) {
        event.revenue = conversion.revenue;
    }
    return {
        events: [event],
    };
}
function normalizeVariationId(id) {
    return id && /^[0-9]+$/.test(id) ? id : null;
}
function makeDecisionSnapshot(event) {
    var _a;
    const { layer, experiment, variation, ruleKey, flagKey, ruleType, enabled, cmabUuid } = event;
    const layerId = layer === null || layer === void 0 ? void 0 : layer.id;
    const experimentId = (_a = experiment === null || experiment === void 0 ? void 0 : experiment.id) !== null && _a !== void 0 ? _a : '';
    const variationId = normalizeVariationId(variation === null || variation === void 0 ? void 0 : variation.id);
    const variationKey = variation ? variation.key : '';
    const campaignId = layerId || experimentId || null;
    return {
        decisions: [
            {
                campaign_id: campaignId,
                experiment_id: experimentId,
                variation_id: variationId,
                metadata: {
                    flag_key: flagKey,
                    rule_key: ruleKey,
                    rule_type: ruleType,
                    variation_key: variationKey,
                    enabled: enabled,
                    cmab_uuid: cmabUuid,
                },
            },
        ],
        events: [
            {
                entity_id: campaignId,
                timestamp: event.timestamp,
                key: ACTIVATE_EVENT_KEY,
                uuid: event.uuid,
            },
        ],
    };
}
function makeVisitor(data) {
    const visitor = {
        snapshots: [],
        visitor_id: data.user.id,
        attributes: [],
    };
    data.user.attributes.forEach(attr => {
        visitor.attributes.push({
            entity_id: attr.entityId,
            key: attr.key,
            type: 'custom',
            value: attr.value,
        });
    });
    if (typeof data.context.botFiltering === 'boolean') {
        visitor.attributes.push({
            entity_id: CONTROL_ATTRIBUTES.BOT_FILTERING,
            key: CONTROL_ATTRIBUTES.BOT_FILTERING,
            type: CUSTOM_ATTRIBUTE_FEATURE_TYPE,
            value: data.context.botFiltering,
        });
    }
    return visitor;
}
export function buildLogEvent(events) {
    var _a;
    const region = ((_a = events[0]) === null || _a === void 0 ? void 0 : _a.context.region) || 'US';
    const url = logxEndpoint[region] || logxEndpoint['US'];
    return {
        url,
        httpVerb: 'POST',
        params: makeEventBatch(events),
    };
}
export const __platforms = ['__universal__'];
//# sourceMappingURL=log_event.js.map